/* This example requires Tailwind CSS v2.0+ */
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { Fragment, useContext, useEffect, useState } from 'react';
import { ReactComponent as DownIcon } from '../assets/icons/down.svg';

import { Link } from 'react-router-dom';
import UserBasicInfoContext from './Context/UserBasicInfoContext';
import UserBasicInfoQRContext from './Context/UserBasicInfoQRContext';


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar(props) {

    const userData = useContext(UserBasicInfoContext);
    const [profile, setProfile] = useState(""); // User Information

    const userBasicInfoQRData = useContext(UserBasicInfoQRContext);

    const [userBasicInfo, setUserBasicInfo] = useState(''); // Company Information


    // User Personal Profile
    useEffect(() => {
        if (userData?.length === 0) {
            return;
        }

        setProfile(userData);
    }, [userData]);



    useEffect(() => {
        if (userBasicInfoQRData?.length === 0) {
            return;
        }
        setUserBasicInfo(userBasicInfoQRData);
    }, [userBasicInfoQRData]);



    return (

        <div className="flex justify-end shadow-on-bottom" >
            {/* <div className="flex items-center pl-8 cursor-pointer">
                <svg onClick={toggleLeftBar} className="w-6 h-6 float-right cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>

                <span onClick={toggleLeftBar} id="page-name" className="self-center pl-3 text-2xl font-medium whitespace-nowrap dark:text-white">{props.name.toString().replace("-", " ")}</span>
            </div> */}


            <Disclosure as="nav" className="z-[1] font-normal">
                {
                    ({ open }) => (
                        <>
                            <div className="mx-auto px-2 py-3 sm:px-6 lg:px-8">
                                <div className="relative flex items-center justify-end h-16">


                                    <div className="absolute inset-y-0 right-0 flex items-center space-x-3 sm:static sm:inset-auto sm:ml-6 sm:pr-0">


                                        {/* Profile dropdown */}
                                        {/* {(userBasicInfo) && */}
                                        <div className="flex items-center justify-center ">
                                            <img
                                                className=" rounded-full h-[50px] w-[50px] object-cover"
                                                src={(userBasicInfo?.logo) ? userBasicInfo?.logo : profile?.photo}
                                                alt="Business Logo"
                                            />
                                            <Menu as="div" className="ml-2 relative">
                                                <div>
                                                    <Menu.Button className="flex ">
                                                        <p className="font-medium px-2">
                                                            {(userBasicInfo?.name === null || userBasicInfo?.name === undefined || userBasicInfo?.name === "")
                                                                ? profile?.name
                                                                : userBasicInfo?.name + " (" + profile?.name + ")"
                                                            }
                                                        </p>
                                                        <span className="sr-only">Open user menu</span>
                                                        <DownIcon />
                                                    </Menu.Button>
                                                </div>
                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-100"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                        <Menu.Item>

                                                            {({ active }) => (
                                                                <Link to="/dashboard/select-company" className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}>
                                                                    Switch
                                                                </Link>
                                                            )}
                                                        </Menu.Item>

                                                        <Menu.Item>

                                                            {({ active }) => (
                                                                <Link to="/dashboard/account-settings" className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}>
                                                                    Settings
                                                                </Link>
                                                            )}
                                                        </Menu.Item>

                                                        <Menu.Item>
                                                            {({ active }) => (
                                                                <Link to={'/dashboard/logout'} className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}>
                                                                    Sign out
                                                                </Link>
                                                            )}
                                                        </Menu.Item>
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>
                                        </div>
                                        {/* } */}
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
            </Disclosure>

        </div>
    )
}
